import { axiosClient } from '@/shared/apis/config';
import { DtoFolderItemType } from '@/shared/constants';
import { ApiResponse } from '@/shared/types/api/response';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { z } from 'zod';
import { QueryKeyUseGetMyBookmarksApi } from './get-my-bookmarks';

/**
 * 북마크 토글 요청 스키마
 */
export const bookmarkToggleRequestSchema = z.object({
  targetType: z.nativeEnum(DtoFolderItemType),
  targetId: z.number(),
});

export type BookmarkToggleRequest = z.infer<typeof bookmarkToggleRequestSchema>;

/**
 * 북마크 토글 응답 스키마
 */
export const bookmarkToggleResponseSchema = z.object({
  isBookmarked: z.boolean(),
});

export type BookmarkToggleResponse = z.infer<
  typeof bookmarkToggleResponseSchema
>;

/**
 * 북마크 토글 API 응답 타입
 */
type PostBookmarkToggleResponse = ApiResponse<BookmarkToggleResponse>;

/**
 * 북마크 토글 API 함수
 *
 * @param request - 북마크 토글 요청 (targetType, targetId)
 * @returns 토글 결과 (isBookmarked)
 */
export const postBookmarkToggleApi = async (request: BookmarkToggleRequest) => {
  const response = await axiosClient.post<PostBookmarkToggleResponse>(
    '/v1.0/bookmarks/toggle',
    request,
  );
  return response.data;
};

/**
 * 북마크 토글 Mutation 훅
 *
 * @returns 북마크 토글 mutation
 */
export const usePostBookmarkToggleApi = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postBookmarkToggleApi,
    onSuccess: () => {
      // 북마크 목록 캐시 무효화
      queryClient.invalidateQueries({
        queryKey: [QueryKeyUseGetMyBookmarksApi],
      });
    },
  });
};
